import { platformApi } from '@/apis';
import { reviveDate } from '@/utils';
import { captureMessage } from '@sentry/react';
import { parseServerSentEvents } from 'parse-sse';
import { useEffect, useState } from 'react';

export function useTelematicsBoxPollStream(imei) {
  const [polls, setPolls] = useState([]);

  useEffect(() => {
    const ctrl = new AbortController();

    async function initiateStream() {
      try {
        const response = await platformApi.get(
          `sse/telematics-box-polls/${imei}`,
          {
            signal: ctrl.signal,
            headers: { accept: 'text/event-stream' },
          },
        );

        for await (const msg of parseServerSentEvents(response)) {
          captureMessage('Received telematics box poll', {
            level: 'debug',
            extra: { msg },
          });

          if (msg.event === 'insert') {
            const poll = JSON.parse(msg.data, reviveDate);
            setPolls((prevPolls) => [poll, ...prevPolls]);
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          captureMessage('Stream aborted', { level: 'debug' });
        } else {
          throw error;
        }
      }
    }

    initiateStream();

    return () => {
      ctrl.abort();
    };
  }, [imei]);

  return polls;
}
